import React, { useMemo } from 'react'

import { useConfig } from './_load/ConfigLoader'
import { useSaveConfig } from './_request/saveConfig'
import Form from '../../../../packages/kiti/components/form/form/Form'
import GeneralSection from './sections/GeneralSection'
import SubmitBar from '../../../../packages/kiti/components/form/SubmitBar'
import { convertSecondsToSla } from './_request/cleanRequest'

const EditConfigForm = () => {
  const config = useConfig()

  const [onSubmit, { loading, error }] = useSaveConfig()

  const initialstate = useMemo(() => {
    if (!config) return { name: 'service_order_sla' }
    const durationInSeconds = config.value.duration_in_seconds
    const slaUnit = config.value.sla_unit
    const slaValue = convertSecondsToSla(durationInSeconds, slaUnit)
    return { ...config, value: { ...config.value, sla_value: slaValue } }
  }, [config])

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={{ ...config, ...initialstate }}>
      <GeneralSection />
      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default EditConfigForm
